// src/utils/slotUtils.js

/**
 * Deterministic Firestore document ID for a barber/date/time combination.
 * Used as a lock document in the `slots` collection to enforce conflict-free bookings.
 */
export function slotDocId(tenantId, barberId, dateStr, time) {
  const safeTime = time.replace(/[^a-zA-Z0-9]/g, "-");
  return `${tenantId}_${barberId}_${dateStr}_${safeTime}`;
}

// Parse "9:00 AM" / "12:30 PM" → total minutes since midnight
function parseTime(str) {
  const [time, meridiem] = str.trim().split(" ");
  let [h, m] = time.split(":").map(Number);
  if (meridiem === "PM" && h !== 12) h += 12;
  if (meridiem === "AM" && h === 12) h = 0;
  return h * 60 + m;
}

// Format total minutes since midnight → "9:00 AM"
function formatTime(totalMinutes) {
  let h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  const meridiem = h < 12 ? "AM" : "PM";
  if (h === 0) h = 12;
  else if (h > 12) h -= 12;
  return `${h}:${String(m).padStart(2, "0")} ${meridiem}`;
}

// All 30-min windows a booking occupies (start inclusive, exclusive of end)
// e.g. occupiedSlots("2:00 PM", 90) → ["2:00 PM", "2:30 PM", "3:00 PM"]
export function occupiedSlots(startTime, durationMinutes) {
  const startMin = parseTime(startTime);
  const slots = [];
  for (let t = startMin; t < startMin + durationMinutes; t += 30) {
    slots.push(formatTime(t));
  }
  return slots;
}

// Generate 30-min slots between start and end (exclusive of end)
// e.g. generateSlots("9:00 AM", "6:00 PM") → ["9:00 AM", "9:30 AM", ...]
export function generateSlots(start, end) {
  const startMin = parseTime(start);
  const endMin   = parseTime(end);
  const slots = [];
  for (let t = startMin; t < endMin; t += 30) {
    slots.push(formatTime(t));
  }
  return slots;
}

// Default availability: Mon–Sat 9 AM–6 PM, Sunday off
export const DEFAULT_AVAILABILITY = {
  0: null,
  1: { start: "9:00 AM", end: "6:00 PM" },
  2: { start: "9:00 AM", end: "6:00 PM" },
  3: { start: "9:00 AM", end: "6:00 PM" },
  4: { start: "9:00 AM", end: "6:00 PM" },
  5: { start: "9:00 AM", end: "6:00 PM" },
  6: { start: "9:00 AM", end: "6:00 PM" },
};
